import {useEffect} from 'react';

import * as localizationKeys from '../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../services/localization/localizationService';

const useDocumentDescription = () => {
    const localizedStrings = getLocalizedStrings();
    const description = localizedStrings[localizationKeys.META_DESCRIPTION];
    const setDescription = (description) => {
        if (description) {
            document.querySelector('meta[name="description"]').setAttribute('content', description);
        }
    };

    useEffect(() => {
        setDescription(description);
    }, [description]);
};

export default useDocumentDescription;
